const UPDATE_CHECKOUT_AWARDS_BEGIN_DATE = "updateCheckoutAwardsBeginDate";
const UPDATE_CHECKOUT_AWARDS_END_DATE = "updateCheckoutAwardsEndDate";
const UPDATE_CHECKOUT_AWARDS_PRODUCTS = "updateCheckoutAwardsProducts";
const UPDATE_SITE = "updateSite";

const state = {
  checkoutAwardsBeginDate: null,
  checkoutAwardsEndDate: null,
  checkoutAwardsProducts: null,
  site: "ecommerce"
};
const getters = {
  getCheckoutAwardsBeginDate: state => {
    return state.checkoutAwardsBeginDate;
  },
  getCheckoutAwardsEndDate: state => {
    return state.checkoutAwardsEndDate;
  },
  getCheckoutAwardsProducts: state => {
    return state.checkoutAwardsProducts;
  },
  getSite: state => {
    return state.site;
  }
};

const actions = {
  [UPDATE_CHECKOUT_AWARDS_BEGIN_DATE]({ commit }, value) {
    commit(UPDATE_CHECKOUT_AWARDS_BEGIN_DATE, value);
  },
  [UPDATE_CHECKOUT_AWARDS_END_DATE]({ commit }, value) {
    commit(UPDATE_CHECKOUT_AWARDS_END_DATE, value);
  },
  [UPDATE_CHECKOUT_AWARDS_PRODUCTS]({ commit }, value) {
    commit(UPDATE_CHECKOUT_AWARDS_PRODUCTS, value);
  },
  [UPDATE_SITE]({ commit }, value) {
    commit(UPDATE_SITE, value);
  }
};
const mutations = {
  [UPDATE_CHECKOUT_AWARDS_BEGIN_DATE]: (state, value) => {
    state.checkoutAwardsBeginDate = value;
  },
  [UPDATE_CHECKOUT_AWARDS_END_DATE]: (state, value) => {
    state.checkoutAwardsEndDate = value;
  },
  [UPDATE_CHECKOUT_AWARDS_PRODUCTS]: (state, value) => {
    state.checkoutAwardsProducts = value;
  },
  [UPDATE_SITE]: (state, value) => {
    state.site = value;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
